exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".always-small-badge[data-v-0358ad44]{font-size:.75rem}.table-title-details[data-v-0358ad44]{font-weight:700;width:200px}", ""]);

// exports
